// extracted by mini-css-extract-plugin
module.exports = {"content":"item-card_content__2kazS","title":"item-card_title__3WWsv"};